import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { useScreen } from '../styles';

const useStyles = makeStyles((theme) => ({
  activeAbsolute: {
    position: 'absolute',
    height: 'calc(100% - 130px)',
    width: 'calc(100% - 316px)',
    overflow: 'auto',
    padding: theme.spacing(1),

    [theme.breakpoints.down('lg')]: {
      paddingLeft: '0',
      paddingRight: '0',
      width: '100%',
      height: (p) => p.height || window.innerHeight - 194,
    },

    '@media print': {
      position: 'relative',
      width: '100%',
      height: '100%',
    },
  },
  mobile: {
    paddingLeft: '0',
    paddingRight: '0',
    position: 'relative',
    width: '100%',
    height: '100%',
    overflow: undefined,
  },
  active: {
    padding: theme.spacing(1),
    textAlign: 'center',
    [theme.breakpoints.down('lg')]: {
      paddingLeft: '0',
      paddingRight: '0',
    },
    '& > div': {
      textAlign: 'initial',
    },
  },
}));

export default function TabContainer(props) {
  const classes = useStyles(props);
  const { isMobile } = useScreen();

  return (
    <div id="ActiveAbsolute" className={clsx(props.useAbsolute ? classes.activeAbsolute : classes.active, isMobile ? classes.mobile : null)}>
      {props.children}
    </div>
  );
}
